import React, { useState, useEffect } from 'react';
import {  message, Image as AntdImage,
    Popconfirm, Tree, Modal, Result,
    Button, DatePicker, Input, Select, Typography
 } from 'antd';
import { SearchOutlined, CloudUploadOutlined, ExceptionOutlined } from '@ant-design/icons';


import moment from 'moment';
import { useDispatch } from "react-redux";


import { setAIModalState } from "../../../../features/AIIntelligentV7/AIReducer";
import Iconfont from "../../../../components/Iconfont/Iconfont";
import KnowledgeListV7 from "../../../../components/KnowledgeListV7/index";
import Api from "../../../../api";
import {zuStandStore} from "../../../../zustand";
import SelfDesignModal from "../../../../components/SelfDesignModal";
import UploadFile from "../../../personalCenter/components/UploadFile/index";
import SelfTable from "../../../../components/SelfTable/index";
import "./index.scss";

const { RangePicker } = DatePicker;
const {Title, Link} = Typography;
const ContentList = ({
    listDate,
    pagination,
    knowledgeTypeId,
    searchChange,
    searchData,
    paginationChange,
}) => {

    const dispatch = useDispatch();

    const [searchValue, setSearchValue] = useState('');
    const [showSearchBox, setShowSearchBox] = useState(false);

    // 经典案例-项目选择
    const [projectList, setProjectList] = useState([]);
    const [projectId, setProjectId] = useState('');

    // 多选框
    const[showSelect , setShowSelect] = useState(false);

    const [showSearchInputBox, setShowSearchInputBox] = useState(false);

    const zuStandState = zuStandStore((state) => state);
    const [modalFlag2, setModalFlag2] = useState(false);
    const [checkedValue, setCheckedValue] = useState({});

    const operateTypeList = [
        {key: "copy", text: "复制",},
        {key: "move", text: "移动",},
        {key: "download", text: "下载",},
        {key: "edit", text: "补充",},
        {key: "share", text: "分享",},
    ];

    const fileStatusList = [
        {value: 'all',label: '全部'},
        {value: '999',label: '更新中'},
        {value: '0',label: '已拒绝'},
        {value: '1',label: '已分享'},
        {value: '2',label: '审批中'},
        {value: '3',label: '未分享'},
    ]
        
    const [selectedRowKeysObject, setSelectedRowKeysObject] = useState({}); // 记录每一页的选项id
    const [selectedRowObject, setSelectedRowObject] = useState({}); // 记录每一页的选项数据
    const [moreShowId, setMoreShowId] = useState(null); // 显示的哪个更多弹窗
    const [fileHistory, setFileHistory] = useState({}); // 历史记录绑定的知识
    const [knowledgeHistoryList, setKnowledgeHistoryList] = useState([]); // 某个知识的历史记录
    const [historyIsShow, setHistoryIsShow] = useState(false); // 历史记录弹窗
    const [spaceTreeIsShow, setSpaceTreeIsShow] = useState(false); // 空间分类tree 弹窗
    const [selectedTreeIds, setSelectedTreeIds] = useState([]); // 选中的空间分类tree
    const [operateType, setOperateType] = useState(null);
    const [moveOrCopyId, setMoveOrCopyId] = useState(null); // 移动或者复制 选中的知识id
    const [isBatch, setIsBatch] = useState(null); // 是否批量操作
    const [showTipsModal, setShowTipsModal] = useState(false); //分享的确认操作框
    const [editFileVlue, setEditFileVlue] = useState({}); // 需要编辑的知识
    const [spaceTree, setSpaceTree] = useState([]); // 空间分类tree 弹窗
    const historyColumns = [
        {
            title: '报告名称',
            dataIndex: 'knowledgeName',
            align: "left",
        },
        {
            title: '更新时间',
            dataIndex: 'createTime',
            width: "160px",
        },

        {
            title: '操作',
            dataIndex: 'operation',
            width: '120px',
            render: (_, record) => {
                return (<Link onClick={() => {
                    let url = `/page/newKnowledge?knowledgeId=${record.id}&type=historyView`;
                    window.open(url);
                }}>
                    查看
                </Link>)
            },
        },
    ];


    useEffect(() => { 
        setSearchValue("");
        setProjectId("");
        setShowSearchInputBox(false);
        console.log("knowledgeTypeId",knowledgeTypeId);
        if(knowledgeTypeId === 'personalData'){
            // 个人资料
            setShowSelect(true);
        }else{
            setShowSelect(false);
            setCheckedValue({});
        }
            
        if(knowledgeTypeId == 2){
            getProject();
        }

        if(knowledgeTypeId === "personalData"){
            getSpaceTree();
        }
    }, [knowledgeTypeId])

    const getSpaceTree = async () => {
        const res = await Api.PersonalCenter.querySpaceTree({});
        if (res && res.code == 0) {
            setSpaceTree(res.data);
        }
    };
    
    const getProject = async() => {
        let res = await Api.Knowledge.getProjectIdAndName({data:{}});
        if(res&&res.code === 0){
            let _data = [{id:'',project_name:'全部项目'},...res.data]
            setProjectList(_data)
        }
    }
    
    const handleChange = (e) => {
        if(!e.target.value){
            searchChange({
                "knowledgeName":""
            });
        }
        setSearchValue(e.target.value);
    };

    const handleSearch = () => {
        searchChange({
            "knowledgeName":searchValue
        });
    };
    
    const changeRangePicker = (dates, dateStrings) =>{
        console.log(dates, dateStrings);
        searchChange({
            "startTime":dateStrings[0],
            "endTime":dateStrings[1]
        });
    }

    // 选择项目
    const projectChange = (value) => {
        searchChange({
            "projectId":value,
        });
        setProjectId(value)
    }

    // 打开上传文件弹窗
    const openUploadFunc = () => {
        zuStandState.changeChoiceFileModalIsShow(true);
    }

    const checkOnchange = (e) => {
        console.log(e)
        let _newList = checkedValue[pagination.pageIndex]
        if(e.target.checked){
            _newList = _newList ? [..._newList,e.target.value]:[e.target.value]
        }else{
            _newList = _newList.filter(item=>item!=e.target.value)
        }
        checkedValue[pagination.pageIndex] = _newList;
        setCheckedValue({...checkedValue})



        let _selectedRowObject = selectedRowObject[pagination.pageIndex]
        if(e.target.checked){
            listDate.map(item=>{
                let knowledgeId = item.id || item.knowledgeId || item.policyId || item.elasticId;
                if(knowledgeId == e.target.value){
                    _selectedRowObject = _selectedRowObject ? [..._selectedRowObject,item] : [item]
                }
            })
        }else{
            _selectedRowObject = _selectedRowObject.filter(item=>{
                let knowledgeId = item.id || item.knowledgeId || item.policyId || item.elasticId;
                return knowledgeId!=e.target.value
            })
        }

        selectedRowObject[pagination.pageIndex] = _selectedRowObject
        setSelectedRowObject({...selectedRowObject});

    }

    const operateFunc = async (type, knowledgeList, isBatch=true) => {
        setMoreShowId(null);
        if (knowledgeList.length < 1) {
            return;
        }
        setIsBatch(isBatch);
        switch (type) {
            case "delete":
                const res = await Api.PersonalCenter.batchDeleteKnowledgeFiles({
                    data: knowledgeList.map(item => String(item.id)),
                    loading: true,
                    loadingText: "知识删除中..."
                });
                if (res.code == 0) {
                    message.success("知识删除成功!");
                    refreshSpaceListF();
                    dispatch(setAIModalState({
                        "refreshSpaceList": new Date().getTime()
                    }))
                }
                break;
            case "copy":
                setMoveOrCopyId(knowledgeList[0].id)
                setSpaceTreeIsShow(true);
                break;
            case "move":
                setMoveOrCopyId(knowledgeList[0].id)
                setSpaceTreeIsShow(true);
                break;
            case "download":
                const file = knowledgeList[0];
                const downloadRes = await Api.PersonalCenter.batchDownloadKnowledgeFiles({
                    data: knowledgeList.map(item => String(item.id)),
                    loading: true,
                    loadingText: "知识下载中..."
                });
                let href = window.URL.createObjectURL(new Blob([downloadRes]));
                const dom = document.createElement("a");
                dom.download = knowledgeList.length > 1 ? `${Date.now()}.zip` : `${file.knowledgeName}.zip`;
                dom.href = href;
                dom.click();
                break;
            case "update":
                goShare(knowledgeList, "updateFile");
                break;
            case "edit":
                goShare(knowledgeList, "share");
                break;
            case "share":
                goShare(knowledgeList, "share");
                break;
            case "history":
                const historyRes = await Api.PersonalCenter.getKnowledgeFileVersions({
                    data: {
                        knowledgeId: knowledgeList[0].id,
                    },
                    loading: true,
                });
                if (historyRes.code == 0 && historyRes.data?.length > 0) {
                    setKnowledgeHistoryList(historyRes.data);
                    setFileHistory(knowledgeList[0])
                    setHistoryIsShow(true);
                } else {
                    message.warning("暂无历史版本!");
                }
                break;
        }

        setOperateType(type);
    }

    // 去分享
    const goShare = (knowledgeList, type) => {
        if (knowledgeList?.length > 0) {

            let value = knowledgeList.map(item => {
                return {
                    fileName: item.knowledgeName,
                    fileId: item.relationFileId,
                    fileType: item.fileType,
                    id: item.id,
                    knowledgeId: item.id,
                }
            })
            
            setEditFileVlue({
                knowledgeList:value,
                editType: type, //share 分享 补充文章信息。updateFile 更新
            })
            checkInformation(value,{
                knowledgeList:value,
                editType: type, //share 分享 补充文章信息。updateFile 更新
            });

        } else {
            message.warning("请选择需要分享的知识！");
        }
    }

    // 检查文件信息是否想同，或者未填写信息
    const checkInformation = async(list, editFileList) => {
        let knowledgeIds = [], data = list;
        data.map(item=>{
            knowledgeIds.push(item.knowledgeId)
        })
        try{
            let res = await Api.Knowledge.checkKnowledgeInfo({
                data: knowledgeIds,
                loading: true,
                loadingText: "数据查询中..."
            });
            if (res && res.code === 0) {
                // 0一致 1不一致 2信息未填写
                if(res.data === 1){
                    setShowTipsModal(true);
                }else{
                    goEditKnoeledge('',editFileList)
                }
            }
        }catch(e){}
    }

    const goEditKnoeledge = (type,editFileList) => {
        sessionStorage.setItem("shareBeforePath", location.href);
        let _editFileList = editFileList ? editFileList: editFileVlue
        sessionStorage.setItem("editFileVlue", JSON.stringify({
            ..._editFileList,
            operationType:type
        }));
        setEditFileVlue({});
        window.open(`/page/editKnowledge`);
        setShowTipsModal(false)
    }

    // 复制/移动 知识到空间分类
    const moveOrCopyFunc = async (spaceId, knowledgeIds, type) => {
        let func = Api.PersonalCenter.batchCopyKnowledgeFiles;
        let text = "复制";
        if (type === "move") {
            text = "移动";
            func = Api.PersonalCenter.batchMoveKnowledgeFiles;
        }
        const res = await func({
            data: {
                "knowledgeIds": knowledgeIds,
                "spaceTypeId": spaceId,
            },
            loading: true,
            loadingText: text + "中...",
        });

        if (res?.code == 0) {
            message.success(text + "成功！");
            
            refreshSpaceListF();
        }
    }

    const refreshSpaceListF = () => { 
        setSelectedTreeIds([]);
        setMoveOrCopyId(null);
        setSpaceTreeIsShow(false);
        setCheckedValue({});
        setSelectedRowObject({});
        dispatch(setAIModalState({
            "refreshSpaceList": new Date().getTime()
        }))
    }

    const personalDataStatusChange = (value)=>{
        if(value === '999'){
            searchChange({
                "updateStatus": 1,
                "knowledgeCheckStatus": null
            });
        }else{
            searchChange({
                "updateStatus": null,
                "knowledgeCheckStatus": value === 'all' ?  null : parseInt(value)
            });
        }
        // {value: 'all',label: '全部'},
        // {value: '999',label: '更新中'},
        // {value: '0',label: '已拒绝'},
        // {value: '1',label: '已分享'},
        // {value: '2',label: '审批中'},
        // {value: '3',label: '未分享'},
    }

    let rowKeyList = [];
    let rowList = [];
    let rowKeyObj = {};
    let isHaveSharedOrApplying = false;
    for (const key in checkedValue) {
        let keys = checkedValue[key] || [];
        rowKeyList.push(...(keys));
        selectedRowObject[key].forEach(item => {
            if (!isHaveSharedOrApplying) {
                const status = String(item.knowledgeCheckStatus);
                isHaveSharedOrApplying = status === "1" || status === "2";
            }
            if (!rowKeyObj[item.id]) {
                rowList.push(item);
                rowKeyObj[item.id] = 1;
            }
        })
    }

    const isHaveSelected = rowKeyList.length > 0;
    let operateParams = rowList;

    return(
        <>
            <div className="knowledgeContentTop">
                <div>
                    <div className="title">知识列表</div>
                    <div className="describe">
                        共找到{pagination.total}个文件
                        <div className={`opration ${showSearchBox ? 'active' : ''}`} onClick={()=>setShowSearchBox(!showSearchBox)}><Iconfont type="icon-guolvqi" /></div>
                    </div>
                </div>

                {knowledgeTypeId === 'personalData' ? <>
                    {isHaveSelected ? <div className={`${isHaveSelected ? "haveSelectedStatus" : ""}`} style={{display: 'flex',justifyContent: 'flex-end'}}>
                        <div className="selectedInfo">
                            <span className="infoDesc">已选择 {rowKeyList.length} 项</span>
                            <span className="cancelSelectedBtn" onClick={() => setCheckedValue({})}>取消选择</span>
                        </div>
                        <div className="selectedOperateBox">
                            <Popconfirm
                                title={(<span><Iconfont type='icon-fail' iStyle={{color: "#F53F3F", marginRight: "0.2rem", top: "-0.1rem"}} />确定删除所选择的知识吗？</span>)}
                                okText={"确定"}
                                cancelText={"取消"}
                                overlayClassName="deletePupConfirmBox"
                                disabled={!isHaveSelected || isHaveSharedOrApplying}
                                onConfirm={() => operateFunc("delete", operateParams)}
                            >
                                <span className="operateBtn" style={isHaveSharedOrApplying ? {cursor: "not-allowed", opacity: "0.3"} : {}}>删除</span>
                            </Popconfirm>
                            {
                                operateTypeList.map(item => {
                                    const {key, text} = item;
                                    let isLimitKey = ["edit", "share"].includes(key);
                                    if (key === "download") {
                                        return (
                                            <Popconfirm
                                                placement={"top"}
                                                title={(<span><Iconfont type='icon-fail' iStyle={{color: "#F53F3F", marginRight: "0.2rem", top: "-0.1rem"}} />确定下载所选择的知识吗？</span>)}
                                                okText={"确定"}
                                                cancelText={"取消"}
                                                disabled={!isHaveSelected}
                                                overlayClassName="deletePupConfirmBox"
                                                onConfirm={() => operateFunc(key, operateParams)}
                                            >
                                                <span className="operateBtn">{text}</span>
                                            </Popconfirm>
                                        )
                                    }
                                    return (
                                        <span
                                            key={key}
                                            className="operateBtn"
                                            style={(isHaveSharedOrApplying && isLimitKey) ? {cursor: "not-allowed", opacity: "0.3"} : {}}
                                            onClick={() => {
                                                if (isHaveSharedOrApplying && isLimitKey) {
                                                    return
                                                }
                                                operateFunc(key, operateParams)
                                            }}
                                        >{text}</span>
                                    )
                                })
                            }
                        </div>
                    </div>:
                    <div>
                        <div className="foldableInputBox" style={showSearchInputBox ? {border: '1px solid #ccc'}:{}}>
                            <SearchOutlined onClick={()=>setShowSearchInputBox(!showSearchInputBox)}/>
                            {showSearchInputBox&&<Input
                                placeholder={'请输入内容'}
                                style={{width: '190px'}}
                                allowClear={true}
                                onChange={handleChange}
                                value={searchValue}
                                onPressEnter={handleSearch}
                            />}
                        </div>

                        <Button 
                            type="primary" 
                            icon={<CloudUploadOutlined />}
                            disbled={!zuStandState.selectedSpaceTypeId}
                            onClick={() => {
                                if (zuStandState.selectedSpaceTypeId) {
                                    openUploadFunc();
                                } else {
                                    message.warning("请选择单个空间分类！")
                                }
                            }}
                        >上传资料</Button>
                    </div>}
                </>:
                <div>
                    <Input
                        placeholder={'请输入内容'}
                        prefix={<SearchOutlined style={{cursor: 'pointer'}} onClick={handleSearch}/>}
                        style={{width: '190px',marginBottom: '0.5rem'}}
                        allowClear={true}
                        onChange={handleChange}
                        value={searchValue}
                        onPressEnter={handleSearch}
                    />
                </div>}
            </div>
            {showSearchBox && <div className="searchBox">
                <RangePicker 
                    value={searchData.startTime?[moment(searchData.startTime), moment(searchData.endTime)]:[]}
                    ranges={{
                        '今天': [moment(), moment()],
                        '本周': [moment().startOf('week'), moment().endOf('week')],
                        '本月': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    onChange={changeRangePicker}
                />

                {/* 经典案例 - 增加项目选项 */}
                {knowledgeTypeId && knowledgeTypeId == 2 ?(<Select 
                    defaultValue={projectId?projectId:"全部项目"}
                    options={projectList} 
                    onSelect={projectChange}
                    bordered={false}
                    showSearch
                    filterOption={(input, option) =>
                        option.project_name.toLowerCase().includes(input.toLowerCase()) ||
                        option.id
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    } // 同时匹配 label 和 value
                    fieldNames={{
                        label:'project_name',
                        value:'id'
                    }}
                />
                ):""}


                {knowledgeTypeId === 'personalData' && <Select
                    defaultValue="all"
                    style={{
                        width: 120,
                    }}
                    bordered={false}
                    options={fileStatusList}
                    onChange={personalDataStatusChange}
                />}
            </div>}
            
            <KnowledgeListV7 
                listDate={listDate} 
                pagination={pagination}
                paginationChange={paginationChange}
                showSelect={showSelect}
                knowledgeTypeId={knowledgeTypeId}
                checkOnchange={checkOnchange}
                checkedValue={checkedValue[pagination.pageIndex]}
                operateFunc={operateFunc}
                searchData={searchData}
            />

            {/* 文件上传 */}
            <SelfDesignModal
                open={modalFlag2 || zuStandState.choiceFileModalIsShow}
                centered={true}
                closeIcon={false}
                closable={false}
                maskClosable={false}
                wrapClassName={"uploadFileModalBox"}
                destroyOnClose={true}
                content={(
                    <UploadFile
                        isChoiceFile={true}
                        isSelected={false}
                        onCancel={() => {
                            setModalFlag2(false);
                            zuStandState.changeChoiceFileModalIsShow(false);
                        }}
                        uploadType={"knowledge"}
                    />
                )}
            />

            {/* 知识 移动/复制 到分类空间 */}
            <SelfDesignModal
                open={spaceTreeIsShow}
                title={`${isBatch ? "【批量】" : ""}${operateType === "move" ? "移动" : "复制"}知识到空间分类`}
                width={600}
                centered={true}
                closable={true}
                maskClosable={true}
                wrapClassName={"spaceTreeListModalBox"}
                destroyOnClose={true}
                cancelText={"取消"}
                okText={"确定"}
                onCancel={() => {
                    setSelectedTreeIds([]);
                    setMoveOrCopyId(null);
                    setSpaceTreeIsShow(false);
                }}
                onOk={() => {
                    if (selectedTreeIds?.length > 0) {
                        moveOrCopyFunc(selectedTreeIds[0], isBatch ? rowKeyList : [moveOrCopyId], operateType);
                    } else {
                        message.warning("请选择空间分类!");
                    }
                }}
                content={(
                    <div>
                        <Tree
                            style={{marginLeft: 30}}
                            defaultExpandAll={true}
                            multiple={false}
                            checkable={false}
                            selectedKeys={selectedTreeIds}
                            treeData={spaceTree}
                            fieldNames={{ title: 'name', key: 'id', children: 'children' }}
                            rootClassName={"spaceTreeBox"}
                            onSelect={(selectedKeys) => setSelectedTreeIds(selectedKeys)}
                        />
                    </div>
                )}
            />

            {/* 知识历史版本 */}
            <SelfDesignModal
                open={historyIsShow}
                width={800}
                title={`${fileHistory?.knowledgeName}-历史版本`}
                centered={true}
                closable={true}
                maskClosable={true}
                wrapClassName={"historyListModalBox"}
                destroyOnClose={true}
                onCancel={() => {
                    setHistoryIsShow(false);
                    setKnowledgeHistoryList([]);
                    setFileHistory({});
                }}
                content={(
                    <div>
                        <SelfTable
                            selfClassName={"aiTableClass"}
                            rowKey="id"
                            bordered={false}
                            dataSource={knowledgeHistoryList}
                            columns={historyColumns}
                        />
                    </div>
                )}
            />

            <Modal
                title=""
                open={showTipsModal}
                destroyOnClose={true}
                maskClosable={false}
                footer={null}
                width={660}
                onCancel={()=>{setShowTipsModal(false)}}
                wrapClassName={"resultTipsBox"}
            >
                <Result
                    icon={<div className="iconBox iconWarning">
                        <ExceptionOutlined />
                    </div>}
                    title="部分文档基本信息缺失"
                    subTitle="请确认每篇文档基本信息的完整性"
                    extra={[
                        <Button onClick={()=>{setShowTipsModal(false)}}>取消分享</Button>,
                        <Button onClick={()=>goEditKnoeledge('editBatch')}>批量修改</Button>,
                        <Button onClick={()=>goEditKnoeledge('editOneByOne')} type="primary">逐篇确认</Button>,
                    ]}
                />
            </Modal>
        </>
    )
}

export default ContentList;
